import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PhoneProps {
    children: ReactNode
    className?: string
    screenClassName?: string
    style?: CSSProperties
}

/**
 * A scalable phone frame. Every radius and inset is a percentage,
 * so the same component works at 120px and at 360px wide.
 */
export const Phone: FC<PhoneProps> = ({ children, className, screenClassName, style }) => {
    return (
        <div
            className={cn('relative aspect-[9/19] rounded-[16%/7.6%] bg-ink p-[2.8%] shadow-[0_40px_80px_-32px_rgb(30_30_30/0.5),0_0_0_1px_rgb(0_0_0/0.08)]', className)}
            style={style}
        >
            <div className={cn('relative h-full w-full overflow-hidden rounded-[13.5%/6.4%] bg-paper', screenClassName)}>
                {children}
            </div>

            <span
                aria-hidden='true'
                className='absolute left-1/2 top-[3.4%] z-30 h-[3%] w-[30%] -translate-x-1/2 rounded-full bg-ink'
            />
        </div>
    )
}
